import React, { useCallback, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { VuiButton } from '../../../../../vodea/@vodea-ui/components/VuiButton';
import { useLocation, useNavigate } from 'react-router-dom';

const ButtonBack: React.FC<any> = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleOnClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    if (location && location.key === 'default') {
      return navigate('/');
    }

    navigate(-1);
  }, [location])

  const handleOpen = useCallback(() => {
    setIsOpen(true);
  }, []);

  return (
    <>
      <Modal show={isOpen} onHide={handleOnClose} backdrop={'static'} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div>Are you sure want to go back?</div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant={'light'} onClick={handleOnClose}>
            Cancel
          </Button>
          <VuiButton forSubmit={true} label={'Back'} onClick={onSubmit} />
        </Modal.Footer>
      </Modal>

      <VuiButton
        label="Back"
        onClick={handleOpen}
        customClass="btn-pay save"
      />
    </>
  );
}

export default ButtonBack;